// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__23KM5","btnRed":"styles_btnRed__1Nqcr","app":"styles_app__N9nz7"};